import React from 'react';

import { SkeletonImage, SkeletonText } from 'components/Skeleton';

import './ProductItemSkeleton.scss';

function ProductItemSkeleton () {

	return (
		<div className="ProductItemSkeleton">
			<SkeletonImage />
			<SkeletonText lines={2} />
			<SkeletonText header width="40px" />
		</div>
	);

}

export default ProductItemSkeleton;
